import { Notification } from "./notification";

export const notifications: Notification[] = [
    {
        id: 1, 
        title: "New Visitor",
        message: "J ohn Doe has entered the premises",
        time: "2 minutes ago",
        icon: "fa-solid fa-person-walking",
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600",
    },
    {
        id: 2,
        title: "Vehicle Entry",
        message: "New vehicle detected at Gate 1",
        time: "5 minutes ago",
        icon: "fa-solid fa-car",
        iconBg: "bg-green-100",
        iconColor: "text-green-600",
    },
    {
        id: 3,
        title: "Camera Alert",
        message: "Motion detected in Camera 3",
        time: "10 minutes ago",
        icon: "fa-solid fa-video",
        iconBg: "bg-red-100",
        iconColor: "text-red-600",
    }
];